import stringify from 'json-stringify-safe';
import { getStackList } from './stack';

/**
 * 校验自定义属性，防止上传混乱.
 * 规则：
 * 1、自定义属性个数不能大于50个。
 * 2、事件名称不能包含特殊字符
 * @param event
 * @param params
 */
export default function checkParams(eventObj: Record<string, any>, maxLength = 50): any {
  const eventInfo = { ...eventObj };
  let errMsg = '';

  if (!eventInfo.event) {
    // event必传
    errMsg = '埋点错误！！！event必传！！！';
    console.error(errMsg, eventInfo);
    return false;
  }

  if (/[ ·！#￥（——）\-：；“”‘、，|《。》？、【】`~!@#%^&*()+<>?:"{},./;'[]]/g.test(eventInfo.event)) {
    // event包含特殊字符
    errMsg = `埋点错误！！！
错误描述：事件名称 "${eventInfo.event}" 不能包含特殊字符
事件名称：${eventInfo.event}
自定义属性：`;
    console.error(errMsg, eventInfo);
    return false;
  }

  const keys = Object.keys(eventInfo);
  if (keys.length === 1) {
    // 只有event，没有自定义属性
    return eventInfo;
  }

  if (keys.length > maxLength) {
    // 先判断自定义属性个数是否超过限制
    errMsg = `埋点错误！！！
错误描述：自定义属性${keys.length}个,已超出限制(${maxLength}个),请减少自定义属性个数！
事件名称：${eventInfo.event}
自定义属性：`;
    console.error(errMsg, eventInfo);
    return false;
  }

  const emptyKeys: string[] = []; // 值为空的key
  const objKeys: string[] = []; // 值为对象的key
  const AZKeys: string[] = []; // 有大写字母的key

  keys.forEach((key) => {
    if (eventInfo[key] === undefined || eventInfo[key] === null) {
      emptyKeys.push(key);
      delete eventInfo[key];
      return;
    }

    if (eventInfo[key] instanceof Error) {
      // 将error对象转成stack_list
      eventInfo.stack_list = getStackList(eventInfo.error);
      delete eventInfo.error;
    }

    if (typeof eventInfo[key] === 'object' && !Array.isArray(eventInfo[key])) {
      // 值为object，json序列化
      objKeys.push(key);
      eventInfo[key] = stringify(eventInfo[key]);
    }

    if (typeof eventInfo[key] === 'string' && eventInfo[key].length >= 1024) {
      // 值为string,限制上传1024字节
      eventInfo[key] = eventInfo[key].slice(0, 1024);
    }

    if (/[A-Z]/g.test(key)) {
      AZKeys.push(key);
      eventInfo[key.toLowerCase()] = eventInfo[key];
      delete eventInfo[key];
    }
  });

  const msgArr = [];
  if (emptyKeys.length > 0) {
    msgArr.push(`${emptyKeys.join(',')} 自定义属性值不符合规范为 undefined 或 null，已被删除。\n`);
  }
  if (objKeys.length > 0) {
    msgArr.push(`${objKeys.join(',')} 自定义属性值不符合规范为 object，已被json序列化。\n`);
  }
  if (AZKeys.length > 0) {
    AZKeys.push(`${objKeys.join(',')} 自定义属性key值不符合规范为！已将大写字母转成小写字母！\n`);
  }

  if (msgArr.length > 0) {
    errMsg = `埋点警告！！！
警告描述：
${msgArr.join('')}
事件名称：${eventInfo.event}
自定义属性：`;
    console.warn(errMsg, eventInfo);
  }

  return eventInfo;
}
